import {isEmpty} from 'lodash-es';
import type {ReactElement} from 'react';
import {useState} from 'react';

import type {SettlementPaymentMethod} from '@afriex/core/domain/types';

import {Button} from '@/components';

import SettlementAccountFormModal from './SettlementAccountFormModal';

type SettlementAccountUpdateButtonProps = {
  initialData?: SettlementPaymentMethod;
  /** Called after a successful save so the list refreshes in place. */
  onSuccess?: () => void | Promise<void>;
};

/**
 * Opens the form modal, for both creating and editing. Mirrors
 * `FeeUpdateButton`: the label and behaviour follow from whether initialData is
 * present, so one component serves the toolbar and each row.
 */
const SettlementAccountUpdateButton = ({
  initialData,
  onSuccess,
}: SettlementAccountUpdateButtonProps): ReactElement => {
  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);
  const label = isEmpty(initialData) ? 'New Account +' : 'Edit';

  return isOpen ? (
    <SettlementAccountFormModal
      isOpen={isOpen}
      onClose={toggle}
      initialData={initialData}
      onSuccess={onSuccess}
    />
  ) : (
    <Button
      variant={isEmpty(initialData) ? 'solid' : 'unStyled'}
      colorScheme="cyan"
      onClick={toggle}
      dataCy={
        isEmpty(initialData)
          ? 'merchant-settlement-accounts-create'
          : 'merchant-settlement-accounts-edit'
      }
    >
      {label}
    </Button>
  );
};

export default SettlementAccountUpdateButton;
